const filterBar = document.querySelector('.Post__Grid__List__Detailed-filter-bar');

window.navigation = () => {
    return {
        scrolled: false,
        mobMenuOpen: false,
        megamenu: null,
        megaMenuOpen: false,
        activeSlideMegaMenu: null,
        activeSecondSlideMegaMenu: null,
        image: null,
        filterBar: filterBar,
        showMenuForm: false,
        searchIsOpen: false,
        searchTerm: '',
        visible: false,
        lastScrollTop: 0,
        navHidden: false,

        async init() {
            const navBar = this.$refs.navBar;
            const subnav = document.querySelector('.subnav');
            const subnavIsVisible = subnav && subnav.offsetParent !== null && window.getComputedStyle(subnav).visibility !== 'hidden';

            if (navBar) {
                pegasus.onResizeFinished(() => {
                    const navHeight = navBar.offsetHeight;
                    const currentSubnav = document.querySelector('.subnav');
                    const subnavIsVisible = currentSubnav && currentSubnav.offsetParent !== null && window.getComputedStyle(currentSubnav).visibility !== 'hidden';
                    const subnavHeight = subnavIsVisible ? currentSubnav.offsetHeight : 0;

                    document.documentElement.style.setProperty('--nav-bar--height', `${navHeight}px`);
                    document.documentElement.style.setProperty('--nav-subnav-height', `${subnavHeight}px`);
                    // Update subnav position on resize (only if visible)
                    if (subnavIsVisible) {
                        currentSubnav.style.top = `${navHeight}px`;
                    }
                }, true);
            }

            await pegasus.wait(200);

            // Initialize scrolled state - use 50px threshold
            this.scrolled = window.scrollY > 50;

            // Initialize subnav position (only if visible)
            if (navBar) {
                const navHeight = navBar.offsetHeight;
                const subnavHeight = subnavIsVisible ? subnav.offsetHeight : 0;

                document.documentElement.style.setProperty('--nav-bar--height', `${navHeight}px`);
                document.documentElement.style.setProperty('--nav-subnav-height', `${subnavHeight}px`);

                if (subnavIsVisible) {
                    subnav.style.top = `${navHeight}px`;
                }
            }

            this.initScrollHandling();
            this.visible = true;
        },

        initScrollHandling() {
            let ticking = false;
            
            window.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        this.handleScroll();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
        },
        
        handleScroll() {
            let st = window.scrollY;

            const newScrolledState = st > 50;
            if (this.scrolled !== newScrolledState) {
                this.scrolled = newScrolledState;
            }

            const navWrapper = this.$refs.navWrapper;
            if (!navWrapper) return;

            const navBar = this.$refs.navBar;
            const navBarHeight = navBar ? navBar.offsetHeight : 0;

            // Hide nav on scroll down, show on scroll up or near top
            if (st > this.lastScrollTop && st > 200) {
                if (!this.navHidden) {
                    document.documentElement.style.setProperty('--nav-offset', `-${navBarHeight}px`);
                    this.navHidden = true;
                }
            } else if (st < this.lastScrollTop || st <= 200) {
                if (this.navHidden) {
                    document.documentElement.style.setProperty('--nav-offset', '0px');
                    this.navHidden = false;
                }
            }

            // Always show nav when menus are open
            if (this.megaMenuOpen || this.mobMenuOpen || this.searchIsOpen) {
                document.documentElement.style.setProperty('--nav-offset', '0px');
                this.navHidden = false;
            }

            this.lastScrollTop = st;
        },
        
        lockScroll() {
            const body = document.getElementsByTagName("body")[0];
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth; // Calculate scrollbar width
        
            body.style.overflow = 'hidden';
            body.style.paddingRight = `${scrollbarWidth}px`; // Add padding to offset the content shift
            
            const bodyOverlay = document.querySelector('.body-overlay');
            if (bodyOverlay) {
                bodyOverlay.style.display = 'block';
                bodyOverlay.classList.remove('hidden');
            }
        },
        
        unlockScroll() {
            const body = document.getElementsByTagName("body")[0];
        
            body.style.overflow = 'auto';
            body.style.paddingRight = ''; // Remove the padding to restore normal layout
            
            const bodyOverlay = document.querySelector('.body-overlay');
            if (bodyOverlay) {
                bodyOverlay.style.display = 'none';
            }
        },
        
        closeMegaMenu(e) {
            e.stopPropagation(); // Prevent event bubbling

            this.megamenu = null;
            this.megaMenuOpen = false;
            this.showMenuForm = false;
            this.searchIsOpen = false;
            setTimeout(() => {
                this.activeSlideMegaMenu = null;
                this.activeSecondSlideMegaMenu = null;
            }, 300);
            this.$root.classList.remove('nav-open');
            this.unlockScroll();
        },
        toggleMegaMenu(menuItemID, e) {
            e.stopPropagation(); // Prevent event bubbling

            // Check if the menu is already open for this ID
            if (this.megamenu === menuItemID) {
                this.megamenu = null;
                this.megaMenuOpen = false;
                this.showMenuForm = false;
                this.activeSlideMegaMenu = null;
                this.activeSecondSlideMegaMenu = null;
                this.$root.classList.remove('nav-open');
                this.unlockScroll();
            } else {
                this.megamenu = menuItemID;
                this.megaMenuOpen = true;
                this.showMenuForm = false;
                this.activeSlideMegaMenu = null;
                this.activeSecondSlideMegaMenu = null;
                this.$root.classList.add('nav-open');
                this.lockScroll();
                
                // Ensure alert banner is visible when menu opens
                const alertBanner = this.$el.querySelector('.AlertBanner');
                if (alertBanner) {
                    alertBanner.classList.remove('-hide-alert');
                    this.navHidden = false;
                }
            }

        },
        openSlideMegaMenu(menuItemID, secondMenu = false) {
            this.activeSlideMegaMenu = menuItemID;
            if (secondMenu) {
                this.activeSecondSlideMegaMenu = true;
            }
        },
        closeSlideMegaMenu() {
            this.activeSlideMegaMenu = null;
        },
        openSecondSlideMegaMenu() {
            this.activeSecondSlideMegaMenu = true;
        },
        closeSecondSlideMegaMenu(secondMenu = false) {
            this.activeSecondSlideMegaMenu = null;
            if (secondMenu) {
                this.activeSlideMegaMenu = null;
            }
        }
    }
}
